<template>
  <div class="pb20" v-loading="loading">
    <div class="w100 pl20 pr20 pb20 flex-box">
      <Sift class="w60" ref="sift" :sift-data="siftData" :col="12" v-if="siftData.length" @change="initPage" />
      <div class="ml10">
        <el-button v-if="siftData.length > 0" type="primary" :loading="loading" @click="initPage(null)">查询</el-button>
        <el-button v-if="hasRole" type="success" :disabled="!checkBox.length" :loading="loading" @click="editDate(null)">批量添加</el-button>
        <el-button v-if="hasRole" :disabled="!checkBox.length" :loading="loading" @click="checkBox = []">取消勾选</el-button>
        <el-button v-if="hasRole" type="warning" :loading="loading" @click="showTerm">查询学期</el-button>
      </div>
    </div>

    <div class="w100 pb20">
      <p class="w100 mb10 tx-c font-24">河池学院 {{ schoolYear }} 学年校历</p>
      <p class="w100 mb10 tx-c font-16" v-if="semester">第{{ semester == 1 ? '一' : '二' }}学期（ <span class="red">{{ starttime }}</span> 至 <span class="red">{{ endtime }}</span> ）</p>
      <!-- <p class="w100 mb20 tx-c font-24">{{ month }}月</p> -->
      <div class="w100 mb20 flex-box ju-c">
        <el-button size="mini" :disabled="monthIndex == 0" @click="clickMonth(Number(monthIndex) - 1)"><i class="el-icon-arrow-left"></i></el-button>
        <span class="ml20 mr20 font-24">{{ showMonth }}</span>
        <el-button size="mini" :disabled="monthIndex == monthList.length - 1" @click="clickMonth(Number(monthIndex) + 1)"><i class="el-icon-arrow-right"></i></el-button>
      </div>

      <div class="w100 flex-box ju-c">
        <table class="radius calendar-table">
          <tr class="font-16">
            <td class="line po-r" :style="{ 'background-image': `url(${baseUrl}images/calendar.png)` }">
              <span class="po-a" style="top: 10px; right: 10px;">星期</span>
              <span class="po-a" style="bottom: 10px; left: 10px;">教学周</span>
            </td>
            <td>一</td>
            <td>二</td>
            <td>三</td>
            <td>四</td>
            <td>五</td>
            <td class="red">六</td>
            <td class="red">日</td>
          </tr>
          <tr v-for="(item, index) in list" :key="index">
            <td class="font-16" style="color: #499ff8;">{{ isWeek(item.week) }}</td>
            <td class="po-r cu-p date-item" v-for="(val, key) in item.list" :key="key" :class="itemClass(val, key)" @click="clickItem(val)">
              <span class="xiu" v-show="val.isvacation == '1'">休</span>
              <span class="ban" v-show="val.isvacation == '2'">班</span>
              <p class="font-24">{{ val.indexDate }}</p>
              <p class="mc red font-16 ellipsis" style="width: 4em" v-if="val.items && val.items.length">{{ val.items[0] }}</p>

              <div class="edit" v-if="hasRole && semester" @click.stop="editDate(val)">
                <i class="myfont icon-bianji"></i>
              </div>

              <el-checkbox v-model="checkBox" v-if="hasRole && semester" @click.stop.native="() => {}" class="edit-check" :label="`${val.wid},${val.currentdateStr}`">{{ '' }}</el-checkbox>
            </td>
          </tr>
        </table>
        <div class="po-r date-main">
          <div class="po-a w100 h100 of-y">
            <p class="pt20 tx-c font-18">本月共 <span class="red">{{ workDay }}</span> 个工作日</p>
            <div class="pt20 pb20 pl20 pr20" v-if="items">
              <p class="w100 mt20 mb20 tx-c">
                <span class="font-48">{{ items.indexDate }}</span>
                <span class="ml5 font-14">日</span>
              </p>
              <div class="mb10 flex-box font-16" v-for="(item, index) in items.items" :key="index">
                <span class="">{{ index + 1 }}、</span>
                <p>{{ item }}</p>
              </div>
              <p class="w100 tx-c grey font-14" v-show="!items.items">本日暂无事件</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="mb10 w100 tx-c font-18">说 明</p>
    <div class="flex-box ju-c">
      <el-input :value="explains" style="width: 1040px;" type="textarea" resize="none" readonly autosize placeholder="暂无说明"></el-input>
    </div>

    <CalendarDialog ref="calendarDialog" @init-page="clickMonth(monthIndex)" />
    <CalendarTermDialog ref="calendarTermDialog" @init-page="clickMonth(monthIndex)" />
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import CalendarDialog from "@/components/serveSearch/calendar/CalendarDialog";
import CalendarTermDialog from "@/components/serveSearch/calendar/CalendarTermDialog";

export default {
  name: "Calendar",
  components: {
    Sift,
    CalendarDialog,
    CalendarTermDialog,
  },
  props: ["url", "app-data", "collecting"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      hasRole: false,

      loading: false,
      siftData: [],

      schoolYear: "-",
      semester: 1,
      starttime: "-",
      endtime: "-",
      month: "-",
      explains: "",
      list: [],

      checkBox: [],

      items: null,

      monthList: [],
    };
  },
  computed: {
    monthIndex() {
      let index = 0;
      for (let i in this.monthList) {
        if (this.month == this.monthList[i].value) {
          index = i;
        }
      }
      return index * 1;
    },
    showMonth() {
      let str = "-月";
      for (const item of this.monthList) {
        if (this.month == item.value) {
          str = item.label;
        }
      }
      return str;
    },
    workDay() {
      let day = 0;
      for (const item of this.list) {
        for (let i in item.list) {
          if (
            item.list[i].month &&
            item.list[i].jobDate &&
            ((item.list[i].isvacation != "1" && i < 5) ||
              (item.list[i].isvacation == "2" && i >= 5))
          ) {
            day++;
          }
        }
      }
      return day;
    },
  },
  created() {},
  mounted() {
    this.fetchSiftData();
  },
  methods: {
    clickItem(val) {
      this.items = val;
    },
    editDate(val) {
      // id,日期,事件,是否批量
      let idArr = [],
        dateArr = [],
        itemArr = [],
        isvacation = null,
        isEdit = false;
      if (val) {
        // 点击某天
        idArr.push(val.wid);
        dateArr.push(val.currentdateStr);
        itemArr = val.items ? val.items : [""];
        isvacation = val.isvacation;
        isEdit = true;
      } else {
        // 点击批量
        for (const item of this.checkBox) {
          // 把check的字符串分割成id和date
          const arr = item.split(",");
          // 判断id是否为null，为null改为后台需要的*号
          const idStr = arr[0] == "null" ? "*" : arr[0];
          idArr.push(idStr);
          dateArr.push(arr[1]);
          itemArr = [""];
          isvacation = null;
          isEdit = false;
        }
      }
      this.$refs.calendarDialog.showView(
        idArr,
        dateArr,
        itemArr,
        isvacation,
        isEdit
      );
    },
    clickMonth(index) {
      this.initPage({
        schoolYear: this.schoolYear + "," + this.semester,
        mouth: this.monthList[index].value,
      });
    },
    initPage(clickObj) {
      this.loading = true;
      let obj = {};
      if (clickObj) {
        obj = clickObj;
      } else {
        if (this.siftData.length) {
          obj = this.$refs.sift.getValue();
        }
      }

      this.$http
        .post("/calendar/list", this.$qs.stringify(obj))
        .then(({ data }) => {
          if (data.resCode == 0) {
            // this.list = data.resData;
            this.schoolYear = data.resData.schoolYear;
            this.semester = data.resData.semester;
            this.starttime = data.resData.starttime;
            this.endtime = data.resData.endtime;
            this.month = data.resData.month;
            this.monthList = data.resData.months;
            this.explains = data.resData.explains;
            this.list = data.resData.data;

            this.checkBox = [];
            this.items = null;

            // 如果默认当前月份没设置校历的时候，处理默认月份
            if (!this.monthList) {
              let arr = [];
              let myData = new Date();
              let month =
                myData.getMonth() < 10
                  ? "0" + (myData.getMonth() + 1)
                  : myData.getMonth() + 1;
              this.month = myData.getFullYear() + "-" + month;
              this.schoolYear = myData.getFullYear();

              arr.push({ label: month + "月", value: this.month });
              this.monthList = arr;
              this.$message.warning(
                "当前 " + this.month + " 还未设置校历，请优先设置！"
              );
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchSiftData() {
      this.loading = true;
      this.$http
        .post("/calendar/condition")
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.siftData = data.resData.list;
            this.hasRole = data.resData.hasRole;

            this.$nextTick(() => {
              this.initPage(null);
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 刷新条件列表
    getSiftData() {
      this.loading = true;
      this.siftData = [];

      this.$http
        .post("/calendar/condition")
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.siftData = data.resData.list;
            this.hasRole = data.resData.hasRole;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 是否教学周
    isWeek(str) {
      if (typeof str == "string" && str.indexOf("not") > -1) {
        return "-";
      } else {
        return "第" + str + "周";
      }
    },
    itemClass(val, key) {
      let str = " ";
      // 字体颜色
      if (!val.month) {
        str += "grey ";
      } else {
        if (!val.jobDate) {
          str += "grey ";
        } else {
          if (key == 5 || key == 6) {
            str += "red ";
          }
        }
      }

      // 背景色
      if (!val.jobDate) {
        str += "bg-g ";
      }
      if (val.isvacation == "1") {
        str += "bg-red ";
      } else if (val.isvacation == "2") {
        str += "bg-g ";
      }
      return str;
    },
    showTerm() {
      this.$refs.calendarTermDialog.showView();
    },
  },
};
</script>

<style scoped>
.calendar-table {
  border-collapse: collapse;
  text-align: center;
}

.calendar-table td {
  border: 1px solid #dddddd;
  width: 100px;
  height: 100px;
}

.calendar-table td.line {
  width: 80px;
  background: no-repeat center center;
  background-size: 100% 100%;
}

.date-item .xiu {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: #ed5440;
}

.date-item .ban {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: #969799;
}

.date-item .edit {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: #409eff;
  cursor: pointer;
}

.date-item:hover .edit {
  display: inline-block;
}

.date-item .edit-check {
  position: absolute;
  right: 0;
  bottom: 5px;
  z-index: 1;
}

.date-main {
  width: 240px;
  border: 1px solid #dddddd;
  border-left: none;
}
</style>
